import { UserType } from "../enum";

export class RequestAssistanceModal {
  public contract: string;
  public area: string;
  public subArea: string;
  public option: string | null;
  public optionId: number;
  public message: string;
  public clientEmail: string;
  public clientName: string;
  public coClientEmail: string;
  public coClientName: string;
  public showroomConsultant: string;
  public showroomConsultantEmail: string;
  public loginBy: UserType;
}
